import styled from 'styled-components'

/**
 * 'content' is the feed: one entry per piece of content, whether it carries a
 * repo, a paper, both or neither.
 *
 * Repos and papers had a top-level tab each. What they mostly listed was the same
 * material a third time, sliced differently — so a repo and a paper are now badges
 * on the content entry that carries them and a section of its detail modal, and
 * one list answers what three used to. What that does NOT cover is finding a repo
 * by owner, name, description, language or movement, and reaching a paper the repo
 * agent pulled out of a repo's README that no post mentions at all; both are still
 * here, as what the one list is a list of (see FeedFilterBar's 'Listar').
 *
 * The three tabs that remain answer questions no list of rows does: what the
 * topics are, which repos are moving, and who is working on what.
 */
export type FeedTab = 'content' | 'clusters' | 'projects' | 'metrics' | 'assignments'

const Tabs = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.sm};
  flex-wrap: wrap;
`

interface ViewTabProps {
    /** Transient prop: styled-components must not forward it to the DOM, where
     *  React rejects `active` as a non-boolean attribute on every render. */
    $active?: boolean
}

const ViewTab = styled.button<ViewTabProps>`
  padding: 0.75rem 1.5rem;
  background: ${({ $active, theme }) => ($active ? theme.colors.primary : theme.colors.secondary)};
  color: ${({ $active }) => ($active ? 'white' : 'inherit')};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  cursor: pointer;
  font-weight: 600;
  transition: all ${({ theme }) => theme.transitions.normal};

  &:hover {
    background: ${({ $active, theme }) => ($active ? theme.colors.primary : '#d0dce0')};
  }
`

const TAB_LABELS: { key: FeedTab; label: string }[] = [
    { key: 'content', label: '🗂️ Contenido' },
    { key: 'clusters', label: '🧭 Clusteres' },
    { key: 'projects', label: '🧩 Proyectos' },
    { key: 'metrics', label: '📈 Métricas' },
    { key: 'assignments', label: '🎯 Asignaciones' },
]

interface FeedTabsProps {
    active: FeedTab
    onChange: (tab: FeedTab) => void
    /** When true the admin-only "Asignaciones" tab is shown. */
    isAdmin?: boolean
}

export const FeedTabs: React.FC<FeedTabsProps> = ({ active, onChange, isAdmin = false }) => (
    <Tabs>
        {TAB_LABELS.filter(({ key }) => key !== 'assignments' || isAdmin).map(({ key, label }) => (
            <ViewTab key={key} $active={active === key} onClick={() => onChange(key)}>
                {label}
            </ViewTab>
        ))}
    </Tabs>
)

export default FeedTabs
